// removed by extract-text-webpack-plugin
module.exports = {"answerItem":"answerItem__N0w6a","answerHeader":"answerHeader__bZGrF","answerAuthorAvatar":"answerAuthorAvatar__2ZFOX","answerAuthorName":"answerAuthorName__2RGl9","answerAwardMark":"answerAwardMark__2l17b","answerAwardIcon":"answerAwardIcon__3n78i","answerImageGroup":"answerImageGroup__2WAV4","answerImageWrap":"answerImageWrap__1GeVx","answerDetail":"answerDetail__37_6D","answerContent":"answerContent__Gs6f1","answerData":"answerData__2hyrr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AnswerItem/index.css
// module id = 1505
// module chunks = 0